module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAAM5JREFUaEPtmcsNwjAAQ50WJuHIAU6sUokZOg6nigkyDQPQSfoRK1R6h2DJPdeO4uekiVpqrb2Mn5IJNKYXAo0ByJ/A7fl+rNv+knSXdG6d6MHxF0mfU9+N5TpMX0mXg8J/e232n4B9hfIha7wq/LfRVCgVYglkDbD8uDoEeIbMIQRYflxdvA9zW+4DvAPMYTavUDdmF2IN4OoQ4BkyhxBg+XF1CPAMmUMIsPy4OgR4hszB/zCX/wOsAVSd+wBNEOuzjeIIoUEIwACx3J7ADyt0h0IIrBFaAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile_02.png
// module id = lOkv
// module chunks = 1